import { NavLink } from 'react-router-dom';

import { useCartStore } from '../store/cart.js';
import { labels } from '../labels.js';
import { Icon, type IconName } from './Icon.js';
import styles from './BottomNav.module.css';

const ITEMS: Array<{ to: string; label: string; icon: IconName }> = [
  { to: '/menu', label: labels.nav.menu, icon: 'menu' },
  { to: '/panier', label: labels.nav.cart, icon: 'bag' },
  { to: '/commandes', label: labels.nav.orders, icon: 'receipt' },
];

/**
 * Bottom navigation -- Design System v1.0: four entries at most, icon and
 * label, active state in Cacao.
 */
export function BottomNav() {
  const count = useCartStore((s) => s.itemCount());

  return (
    <nav className={styles.nav} aria-label={labels.nav.label}>
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to !== '/commandes'}
          className={({ isActive }) => `${styles.item} ${isActive ? styles.active : ''}`}
        >
          <span className={styles.icon}>
            <Icon name={item.icon} size={22} />
            {item.to === '/panier' && count > 0 && (
              <span className={styles.count} aria-label={labels.menu.itemCount(count)}>{count > 99 ? '99+' : count}</span>
            )}
          </span>
          <span className={styles.label}>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
